const testimonials = [
  {
    name: 'Амирхан К.',
    company: 'Строительная компания',
    text: 'Отличное качество строп, быстрая доставка. Уже второй год сотрудничаем - очень довольны!',
    rating: 5,
  },
  {
    name: 'Асхат Б.',
    company: 'Логистическая компания',
    text: 'Профессиональный подход, качественная продукция. Рекомендую всем коллегам по отрасли.',
    rating: 5,
  },
  {
    name: 'Талгат В.',
    company: 'Промышленное предприятие',
    text: 'Надежные стропы, соответствуют всем стандартам. Цены адекватные, сервис на высоте.',
    rating: 5,
  },
];

export default testimonials;
